import sizeOptions from './size-options.esm.js';

var widthOptionList = Object.keys(sizeOptions.width);
var heightOptionList = Object.keys(sizeOptions.height);

export { heightOptionList, widthOptionList };
//# sourceMappingURL=types.esm.js.map
